import { useEffect } from 'react'

import { useIntercom } from 'react-use-intercom'

import { useRouter } from 'next/router'

const PageLayout = ({ children }) => {
  const { asPath } = useRouter()
  const { update } = useIntercom()

  useEffect(() => {
    // @ts-ignore
    if (window.Intercom) {
      update({
        hideDefaultLauncher: asPath !== '/' && asPath !== '/login',
      })
    }
  }, [asPath, update])

  return children
}

export default PageLayout
